import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69568ca6ac89830014215f4c/mylesdrive_logistics_hub/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/69568ca6ac89830014215f4c/mylesdrive_logistics_hub/src/styles/index.css");
